/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import styled from "styled-components";
import { datadogRum } from "@datadog/browser-rum";

import { InvoiceDownloadIconPropTypes } from "../admin/billing/lib/types";
import { downloadFile } from "../../utils";
import { getChargebeeInvoiceDownload } from "../../api/billing";
import { redesignTheme } from "../theme/theme";
const fileInvoiceDollar = require("../svg/fileInvoiceDollar.svg");

const StyledLink = styled.a`
  background: ${redesignTheme.color.gray50};
  display: inline-flex;
  height: 32px;
  width: 32px;
  border-radius: 9999px;
  justify-content: center;
  cursor: pointer;
`;

const StyledSpan = styled.span`
  display: inline-flex;
  height: 32px;
  width: 32px;
  border-radius: 9999px;
  justify-content: center;
`;

const StyledImage = styled.img`
  height: 15px;
  width: 12px;
  margin-top: ${redesignTheme.spacing[2.5]};
`;

const StyledI = styled.i`
  height: 15px;
  width: 12px;
  margin-top: ${redesignTheme.spacing[2.5]};
`;

const InvoiceDownloadIcon = ({
  invoiceId,
  testId,
  updateToastMessage,
}: InvoiceDownloadIconPropTypes): React.ReactElement => {
  const [loading, setLoading] = React.useState(false);

  const handleClick = async (): Promise<void> => {
    if (loading) {
      return;
    }

    try {
      setLoading(true);
      const response = await getChargebeeInvoiceDownload({
        invoice_id: invoiceId,
      });

      if (response && response.data) {
        downloadFile(response.data, `Bonusly Invoice #${invoiceId}.pdf`);
        setLoading(false);
        updateToastMessage({
          isOpen: true,
          message: i18n.translate(
            "admin_pages.activity.report_generation_success"
          ),
          type: "success",
        });
      } else {
        throw new Error("Unable to get Chargebee Invoice");
      }
    } catch (error) {
      datadogRum.addError(error);
      updateToastMessage({
        isOpen: true,
        message: i18n.translate(
          "admin_pages.activity.download_invoice_failure"
        ),
        type: "error",
      });
      setLoading(false);
    }
  };

  return loading ? (
    <StyledSpan data-testid={testId}>
      <StyledI className="fa fa-sync fa-spin spinner" />
    </StyledSpan>
  ) : (
    <StyledLink data-testid={testId} onClick={handleClick}>
      <StyledImage src={fileInvoiceDollar} alt="file invoice download" />
    </StyledLink>
  );
};

export default InvoiceDownloadIcon;
